import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'ftr-logout-page',
  template: '<ftr-logout />',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LogoutPage {}
